import React from 'react';
import { FaFacebook, FaLinkedin, FaInstagram, FaWhatsapp, FaTelegram, FaYoutube } from 'react-icons/fa';

const FooterSection = () => {
  return (
    <div className="container-fluid bg-light py-5">
      <div className="row gy-4">

        {/* Logo */}
        <div className="col-12 col-md-3 mb-4 d-flex align-items-start justify-content-start">
          <img
            src="/Assests/Logo.png"
            alt="Sri Takshashila Gurukul Logo"
            className="img-fluid"
            style={{ maxWidth: '350px', marginLeft: '30px', marginTop: '-50px' }}
          />
        </div>

        {/* Content */}
        <div className="col-12 col-md-3 mb-4 text-start">
          <h5 className="fs-3 mb-3">Sri Takshashila Gurukul</h5>
          <p>Trusted by 200+ Satisfied Clients</p>
          <p style={{
            textAlign: "justify",
            maxWidth: "100%",    // Reduce width to 80% of the container
            marginRight:"17px"  // Center the paragraph
          }}>
            <strong>Sri Takshashila Gurukul</strong> is a sanctuary of wisdom, dedicated to those who have the zeal to learn and grow. As a non-profit organization, we focus on the holistic development of such passionate individuals, seeking no personal gain—only the fulfillment of empowering young minds for a brighter future.
          </p>
        </div>

        {/* Contact Information */}
        <div className="col-12 col-md-3 mb-4 text-start">
          <h5 className="fs-3 mb-3">Contact Us</h5>
          <p>
            <i className="bi bi-geo-alt-fill"></i> Sapar Galli Vadagoun, Belagavi 590005, Karnataka
          </p>
          <p>
            <i className="bi bi-telephone-fill"></i> +91 63616 64811
          </p>
          <p>
            <i className="bi bi-envelope-fill"></i> sritakshashila@gmail.com
          </p>
          <p>
            <i className="bi bi-clock-fill"></i> 24/7 Hours Service
          </p>
        </div>

        {/* Social Media Links */}
        <div className="col-12 col-md-3 text-start">
          <h5 className="fs-3 mb-3">Follow us on Social Media</h5>
          <div className="d-flex flex-wrap justify-content-start">
            <a href="https://www.facebook.com/people/Sri-Takshashila-Gurukul/pfbid09ndAnBbn9AjdzvRR84QcVNJh8zj7Eem2gQMqrPo86yC58n6L8uXJCeuamrR8GarGl/" className="text-decoration-none text-dark me-4 mb-2">
              <FaFacebook size={28} />
            </a>
            <a href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGzPCLRFss8kQAAAZQbPdKAag8C5hnqmG8vGsuKNHmpJWARit4rCe7UM0uNdFuC9ZGph6A0QE6ZXovZR3D-x36avNBUVRBp1scqy1HHutLEAaSp_TJkIS_a4zHpFoAadr7BY24=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fsritakshashila-gurukul-385b41306%2F" className="text-decoration-none text-dark me-4 mb-2">
              <FaLinkedin size={28} />
            </a>
            <a href="https://www.instagram.com/sritakshashila/" className="text-decoration-none text-dark me-4 mb-2">
              <FaInstagram size={28} />
            </a>
            <a href="https://www.whatsapp.com/channel/0029VaMRwERDuMRbNDXKsn2d" className="text-decoration-none text-dark me-4 mb-2">
              <FaWhatsapp size={28} />
            </a>
            <a href="https://t.me/SriTakshashilaGurukul" className="text-decoration-none text-dark me-4 mb-2">
              <FaTelegram size={28} />
            </a>
            <a href="https://www.youtube.com/@SriTakshashilaGurukul" className="text-decoration-none text-dark mb-2">
              <FaYoutube size={28} />
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FooterSection;
